<div class="wrapper-modal">
  <div class="wrapper-modal-content add-new">
    <div class="modal-title">{{selectedColumn === null ? ('LIST_SINGLE_PAGE.add_a_new_column' | translate) : ('Update column name' | translate)}}</div>
    <div class="wrapper-input">
      <span class="label-input">{{'LIST_SINGLE_PAGE.column_name' | translate}}</span>
      <div class="custom-input">
        <input type="text" [(ngModel)]="columnName" name="columnName" placeholder="{{'NEW_TEXT.enter_column_name' | translate}}"
          maxlength="20" />
      </div>
      <div class="label-info-input">
        {{'LIST_SINGLE_PAGE.the_maximum_length_of_a_column_name_is_20_characters' | translate}}
        </div>
    </div>
    <div class="modal-buttons">
      <button class="custom-btn custom-btn--outline" (click)="closeModal.emit(true)">
        <span>
          {{'GENERAL.cancel' | translate}}
        </span>
      </button>
      <button class="custom-btn custom-btn--primary" (click)="addColumn()">
        <span>{{selectedColumn === null ?  ('LIST_SINGLE_PAGE.add_a_new_column' | translate) : ('Update column name' | translate)}}</span>
      </button>
    </div>
  </div>
</div>
